const COLOR = {
	light: [139, 133, 169],
	dark: [54, 29, 183],
};
export default function Star({ k, C, type, pos }) {
	const star = k.add([
		k.rect(6, 6, {
			radius: 3,
		}),
		k.color(...COLOR[type]),
		k.pos(...pos),
		k.anchor("center"),
		k.layer("background"),
		k.scale(1),
		k.animate({ relative: true }),
	]);

	return star;
}

export function createStarBG({ k, C, num = 100 }) {
	for (let i = 0; i < num; i++) {
		const star = Star({
			k,
			C,
			type: k.choose(["light", "dark"]),
			pos: [k.rand(0, k.width()), k.rand(0, k.height())],
		});

		star.animate("scale", [1, 0, 1], {
			duration: k.rand(1, 4),
		});
	}
}
